<!-- PAGE HEADER -->

<div class="page-header">
    <h2>Account Settings</h2>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>

<!-- FORM CARD -->
<div class="container">
    <form [formGroup]="signupForm" (ngSubmit)="submit()">

        <p class="required-note"><span>*</span> Required</p>

        <!-- ================= BUSINESS INFORMATION ================= -->
        <section formGroupName="businessInfo">
            <h3>Business Information</h3>

           <div class="delete-account-container" *ngIf="isSuperAdmin">
        <button
            type="button"
            class="button-delete-account"
            (click)="deleteAccount()">
            <i class="pi pi-trash"></i>
            Delete Account
        </button>
    </div>

            <div class="row">
                <div class="field" [ngClass]="displayFieldCss('businessInfo.businessName')">
                    <label><span>* </span>Business/Organization Name</label>
                    <input type="text" formControlName="businessName" maxlength="100" autofocus>
                    <div class="error-message"
                        *ngIf="signupForm | invalidChars:'businessInfo.businessName':ValidationPatterns.ALLOWED_BUSINESS_CHARS as invalidChars">
                        Invalid chars: {{ invalidChars }}
                    </div>
                </div>

                <div class="field" [ngClass]="displayFieldCss('businessInfo.industry')">
                    <label><span>* </span>Industry</label>

                    <select #industrySelect formControlName="industry"
                        (change)="onIndustryChange(industrySelect.value)">
                        <option value="">Select</option>
                        <option *ngFor="let industry of industryList" [value]="industry.industryPk">
                            {{ industry.industryName }}
                        </option>
                    </select>

                    <!-- New input below dropdown -->
                    <input *ngIf="isIndustryOther" type="text" formControlName="industryOther" maxlength="100" />

                    <div class="error-message"
                        *ngIf="signupForm | invalidChars:'businessInfo.industryOther':ValidationPatterns.ALLOWED_BUSINESS_CHARS as invalidChars">
                        Invalid chars: {{ invalidChars }}
                    </div>
                </div>



                <div class="field">
                    <label>Entity Type</label>

                    <select #entityTypeSelect formControlName="entityType"
                        (change)="onEntityTypeChange(entityTypeSelect.value)">
                        <option value="">Select</option>
                        <option *ngFor="let entityType of entityTypeList" [value]="entityType.entityTypePk">
                            {{ entityType.entityTypeName }}
                        </option>
                    </select>

                    <input *ngIf="isEntityTypeOther" type="text" formControlName="entityTypeOther" maxlength="100" />

                    <div class="error-message"
                        *ngIf="signupForm | invalidChars:'businessInfo.entityTypeOther':ValidationPatterns.ALLOWED_BUSINESS_CHARS as invalidChars">
                        Invalid chars: {{ invalidChars }}
                    </div>
                </div>



                <div class="field">
                    <label>Number of Employees</label>
                    <input type="text" formControlName="employees" inputmode="numeric" maxlength="6"
                        (input)="onInput($event)" />

                </div>

            </div>

            <!-- Address row -->
            <div class="row address-row">
                <div class="field" [ngClass]="displayFieldCss('businessInfo.address1')">
                    <label><span>* </span>Address</label>
                
                    <app-google-place-autocomplete [formGroup]="businessInfoForm" address1ControlName="address1" cityControlName="city"
                        stateControlName="state" zipCodeControlName="zip" [maxlength]="60">
                    </app-google-place-autocomplete>
                
                    <div class="error-message"
                        *ngIf="signupForm | invalidChars:'businessInfo.address1':ValidationPatterns.ALLOWED_ADDRESS_CHARS as invalidChars">
                        Invalid chars: {{ invalidChars }}
                    </div>
                </div>

                <div class="field">
                    <label>Address 2</label>
                    <input type="text" formControlName="address2" maxlength="60">
                    <div class="error-message"
                        *ngIf="signupForm | invalidChars:'businessInfo.address2':ValidationPatterns.ALLOWED_ADDRESS_CHARS as invalidChars">
                        Invalid chars: {{ invalidChars }}
                    </div>
                </div>

                <div class="field" [ngClass]="displayFieldCss('businessInfo.city')">
                    <label><span>* </span>City</label>
                    <input type="text" formControlName="city" id="city" maxlength="30">
                    <div class="error-message"
                        *ngIf="signupForm | invalidChars:'businessInfo.city':ValidationPatterns.ALLOWED_CITY_CHARS as invalidChars">
                        Invalid chars: {{ invalidChars }}
                    </div>
                </div>

                <div class="field" [ngClass]="displayFieldCss('businessInfo.state')">
                    <label><span>* </span>State</label>
                    <select formControlName="state" id="state">
                        <option value="">Select</option>
                        <option *ngFor="let state of stateList" [value]="state.stateCode">
                            {{ state.stateName }}
                        </option>
                    </select>
                </div>

                <div class="field" [ngClass]="displayFieldCss('businessInfo.zip')">
                    <label><span>* </span>Zip Code</label>
                    <input type="tel" formControlName="zip" minlength="5" maxlength="10" inputmode="numeric"
                        placeholder="XXXXX-XXXX" mask="00000-9999" [validation]="true" [dropSpecialCharacters]="true">
                </div>
            </div>

            <div class="row">
                <div class="field" [ngClass]="displayFieldCss('businessInfo.phone')">
                    <label><span>* </span>Business Phone </label>
                    <input type="text" formControlName="phone" maxlength="15" inputmode="numeric"
                        placeholder="(XXX) XXX-XXXX" mask="(000) 000-0000" [validation]="true"
                        [dropSpecialCharacters]="true">

                </div>
                <div class="field">
                    <label>Business Fax </label>
                    <input type="text" formControlName="fax" maxlength="15" inputmode="numeric"
                        placeholder="(XXX) XXX-XXXX" mask="(000) 000-0000" [validation]="true"
                        [dropSpecialCharacters]="true">

                </div>
                <div class="field" [ngClass]="displayFieldCss('businessInfo.email')">
                    <label><span>* </span>Business Email</label>
                    <input type="email" formControlName="email" maxlength="100"
                        pattern="^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$">
                    <div class="error-message"
                        *ngIf="signupForm | invalidChars:'businessInfo.email':ValidationPatterns.ALLOWED_EMAIL_CHARS as invalidChars">
                        Invalid chars: {{ invalidChars }}
                    </div>
                </div>

                <div class="field" [ngClass]="displayFieldCss('businessInfo.taxExempt')">
                    <label><span>* </span>Is your business tax exempt?</label>
                    <select #taxExemptSelect formControlName="taxExempt">
                        <option value="">Select</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>

                <div class="field" [ngClass]="displayFieldCss('businessInfo.employerIdentificationNumber')">
                    <label>Employer Identification Number (EIN)</label>
                    <input type="text" formControlName="employerIdentificationNumber" maxlength="10" inputmode="numeric"
                        placeholder="XX-XXXXXXX" mask="00-0000000" [validation]="true" [dropSpecialCharacters]="true">
                </div>
                <div class="field" *ngIf="business?.payDayPerxId">
                    <label>Payday Perx ID</label>
                    <input type="text" [value]="business?.payDayPerxId" readonly tabindex="-1" class="readonly-field">
                </div>
                <div class="field" *ngIf="business?.nscId">
                    <label>National Safety Council ID</label>
                    <input type="text" [value]="business?.nscId" readonly tabindex="-1" class="readonly-field">
                </div>
            </div>
        </section>
        <section>
            <div class="users">
                <h3 class="add-user">Users </h3>
                <button class="button-primary move-right" *ngIf="canEdit" type="button" (click)="addUserProfile()">Add
                    User</button>
            </div>
            <div>
                <p-table [responsive]="true" [value]="userList" [paginator]="false" [rows]="10"
                    [rowsPerPageOptions]="[5,10,25]" [loading]="loading" sortMode="multiple">

                    <!-- Header -->
                    <ng-template pTemplate="header">
                        <tr>
                            <th>
                                Name
                            </th>
                            <th>
                                Role
                            </th>
                            <th>
                                Email
                            </th>
                            <th>
                                Phone
                            </th>
                            <th>
                                Status
                            </th>
                            <th>
                            </th>
                        </tr>
                    </ng-template>

                    <!-- Body -->
                    <ng-template pTemplate="body" let-contact>
                        <tr>
                            <td>{{ contact.firstName }} {{ contact.lastName }}</td>
                            <td>{{ getRole(contact.roleCode) }}</td>
                            <td>{{ contact.email }}</td>
                            <td>{{ formatPhoneNumber(contact.contactPhone) }}</td>
                            <td>{{ contact.isActive ? 'Active' : 'Inactive' }}</td>
                            <td class="action-cell">
                                <i *ngIf="canEditContact(contact.roleCode) && userEmail !== contact.email"
                                    class="pi pi-envelope action-icon" (click)="welcomeUser(contact.email)"></i>
                                <!-- <i *ngIf="!(canEdit || userEmail === contact.email)" class="pi pi-eye action-icon"
                                    (click)="editUserProfile(contact.contactId)"></i> -->
                                <i *ngIf="canEditContact(contact.roleCode) || userEmail === contact.email"
                                    class="pi pi-pencil action-icon" (click)="editUserProfile(contact.contactId)"></i>
                                <i *ngIf="canEditContact(contact.roleCode) && userEmail !== contact.email"
                                    class="pi pi-trash action-icon" (click)="deleteUserProfile(contact.contactId)"></i>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </section>

        <!-- ================= W9 Document ================= -->
        <section class="w9">
            <div class="users">
                <h3>IRS Form W-9</h3>
                <button *ngIf="isW9NotUploadedOrRejected" class="button-primary move-right" type="button" (click)="uploadW9()">Start Business Verification</button>
            </div>

            <div>
                <p-table [responsive]="true" [value]="w9List" [paginator]="false" [rows]="10" [loading]="loading">

                    <!-- Header -->
                    <ng-template pTemplate="header">
                        <tr>
                            <th>
                                Uploaded W-9
                            </th>
                            <th>
                                Upload Date
                            </th>
                            <th>
                                W-9 Status
                            </th>
                            <th>
                            </th>
                        </tr>
                    </ng-template>

                    <!-- Body -->
                    <ng-template pTemplate="body" let-w9>
                        <tr>
                            <td>{{ w9.w9UploadedFileName }}</td>
                            <td>{{ w9.w9UploadedDate | date:'MM/dd/yyyy' }}</td>
                            <td>{{ w9.w9Status }}</td>
                            <td class="action-cell"><i (click)="downloadFile(w9.w9UploadedFileName)"
                                    class="pi pi-download action-icon"></i>
                                <i class="pi pi-upload action-icon"
                                    title="Replace W-9" (click)="goToReplaceW9(w9)">
                                </i>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <!-- <div class="row">
                <div class="field">
                    <label>Uploaded W-9 </label>
                    <label>{{w9UploadedFileName }}</label>
                </div>

                <div class="field">
                    <label>Upload Date </label>
                    <label>{{w9UploadedDate | date:'MM/dd/yyyy'}}</label>
                </div>

                <div class="field">
                    <label>W-9 Status </label>
                    <label>{{w9Status }}</label>
                </div>
            </div> -->
        </section>

        <div class="actions mt-30 mb-30">
            <button type="button" (click)="cancel()">Close</button>
            <button type="submit">Save</button>
        </div>
    </form>
</div>
<p-dialog header="{{ dialogSummary }}"
    [styleClass]="dialogSummary === 'Success' ? 'success-dialog' : 'success-dialog error'" [(visible)]="locListModalDlg"
    [closable]="false" [closeOnEscape]="false" [modal]="true" [dismissableMask]="false" [style]="{ width: '580px' }"
    [breakpoints]="{ '640px': '95vw' }">

    <div class="dialog-body" [innerHTML]="dialogMsg"></div>

    <ng-template pTemplate="footer">

        <div class="actions">

            <!-- Unsaved Changes -->
            <ng-container *ngIf="dialogType === 'unsaved'">

                <button type="button" class="button-primary" (click)="stayOnPage()">
                    Continue Editing
                </button>

                <button type="button" class="button-primary" (click)="leavePage()">
                    Leave
                </button>

            </ng-container>

            <!-- Delete Confirmation -->
            <ng-container *ngIf="dialogType === 'delete'">

                <button type="button" class="button-secondary" (click)="locListModalDlg = false">
                    Cancel
                </button>

                <button type="button" class="button-primary" (click)="confirmDeleteAccount()">
                    Delete Account
                </button>

            </ng-container>

            <!-- Success / Error / Cannot Delete -->
            <ng-container *ngIf="dialogType === 'success'
                || dialogType === 'error'
                || dialogType === 'cannotDelete'">

                <button type="button" class="button-primary" (click)="okClickedV2()">
                    OK
                </button>

            </ng-container>

        </div>

    </ng-template>
</p-dialog>